export default "__VITE_ASSET__CSeTR8gA__"